// global tracking
export const CHANGE_CURRENT_SCREEN = 'CHANGE_CURRENT_SCREEN'
export const CHANGE_SEARCH_TERM = 'CHANGE_SEARCH_TERM'
export const SWITCH_ONBOARD_SCREEN = 'SWITCH_ONBOARD_SCREEN'
export const DISPLAY_SIDEBAR = 'DISPLAY_SIDEBAR'

// modal store
export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const SHOW_REMOVE_MODAL = 'SHOW_REMOVE_MODAL'
export const HIDE_REMOVE_MODAL = 'HIDE_REMOVE_MODAL'
export const SHOW_CONFIRM_MODAL = 'SHOW_CONFIRM_MODAL'
export const HIDE_CONFIRM_MODAL = 'HIDE_CONFIRM_MODAL'
export const SET_EXPORT_MODAL = 'SET_EXPORT_MODAL'
export const SET_ALLOW_LIST_MODAL = 'SET_ALLOW_LIST_MODAL'
export const SET_ACCESS_CODE_MODAL = 'SET_ACCESS_CODE_MODAL'

// layout
export const SET_LAYOUT = 'SET_LAYOUT'

// login
export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAIL = 'LOGOUT_FAIL'
export const SIGN_UP = 'SIGN_UP'
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS'
export const SIGN_UP_FAIL = 'SIGN_UP_FAIL'
export const IS_REQUESTING_RESET = 'IS_REQUESTING_RESET'
export const IS_REQUESTING_SUCCESS = 'IS_REQUESTING_SUCCESS'
export const SET_EMAIL_RESET_PASSWORD = 'SET_EMAIL_RESET_PASSWORD'
export const SET_HEADERS = 'SET_HEADERS'
export const CHANGING_PASSWORD = 'CHANGING_PASSWORD'
export const RESET_AUTH_STORE = 'RESET_AUTH_STORE'
export const RESET_STORE = 'RESET_STORE'

// Products
export const LOAD_PRODUCTS = 'START_LOAD_PRODUCTS'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const LOAD_BUNDLES = 'LOAD_BUNDLES'
export const SET_BUNDLES = 'SET_BUNDLES'
export const RESET_PRODUCT_DETAILS = 'RESET_PRODUCT_DETAILS'
export const LOAD_PRODUCT_DETAILS = 'LOAD_PRODUCT_DETAILS'
export const PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND'
export const SET_PRODUCT_DETAILS = 'SET_PRODUCT_DETAILS'
export const SET_PRODUCT_VARIANTS = 'SET_PRODUCT_VARIANTS'
export const SET_VARIANT = 'SET_VARIANT'
export const SET_ALL_VARIANTS = 'SET_ALL_VARIANTS'
export const SET_PRODUCT_VARIANTS_IMAGES = 'SET_PRODUCT_VARIANTS_IMAGES'
export const SET_VARIANT_DICTIONARY = 'SET_VARIANT_DICTIONARY'
export const SET_VARIANT_TYPES = 'SET_VARIANT_TYPES'
export const SET_VARIANT_COLORS = 'SET_VARIANT_COLORS'
export const UPDATE_VARIANT_COLOR = 'UPDATE_VARIANT_COLOR'
export const SET_VARIANT_SIZES = 'SET_VARIANT_SIZES'
export const UPDATE_VARIANT_SIZES = 'UPDATE_VARIANT_SIZES'
export const SET_DEFAULT_SELECTION = 'SET_DEFAULT_SELECTION'
export const LOAD_BUNDLE_DETAILS = 'LOAD_BUNDLE_DETAILS'
export const BUNDLE_NOT_FOUND = 'BUNDLE_NOT_FOUND'
export const SET_BUNDLE_DETAILS = 'SET_BUNDLE_DETAILS'
export const SET_BUNDLE_ITEMS = 'SET_BUNDLE_ITEMS'
export const RESET_PRODUCT_STATE = 'RESET_PRODUCT_STATE'

// profile
export const LOAD_USER_PROFILE = 'LOAD_USER_PROFILE'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'
export const RESET_PROFILE_STATE = 'RESET_PROFILE_STATE'
export const UPDATING_USER_PROFILE = 'UPDATE_USER_PROFILE'
export const SET_IDP_PROFILE = 'SET_IDP_PROFILE'
export const SET_EXISTING_IDP_PROFILE = 'SET_EXISTING_IDP_PROFILE'
export const UPDATING_IPD_SETTING = 'UPDATING_IPD_SETTING'

// orders
export const SET_ALL_TEAM_ORDERS = 'SET_ALL_TEAM_ORDERS'
export const SET_TOTAL_ORDER_RECORDS = 'SET_TOTAL_ORDER_RECORDS'
export const LOAD_ORDERS_LIST = 'LOAD_ORDERS_LIST'
export const SET_ORDERS_LIST = 'SET_ORDERS_LIST'
export const LOAD_ORDER_DETAIL = 'LOAD_ORDER_DETAIL'
export const SET_ORDER_DETAIL = 'SET_ORDER_DETAIL'
export const START_SEARCH = 'START_SEARCH'
export const CHANGE_SEARCH_RESULTS = 'CHANGE_SEARCH_RESULTS'
export const END_SEARCH = 'END_SEARCH'
export const DESTROY_ORDERS_LIST = 'DESTROY_ORDERS_LIST'
export const ADD_PRODUCT_TO_SHOPPING_BAG = 'ADD_PRODUCT_TO_SHOPPING_BAG'
export const REMOVE_PRODUCT_FROM_SHOPPING_BAG =
  'REMOVE_PRODUCT_FROM_SHOPPING_BAG'
export const INCREASE_ITEM_SHOPPING_BAG = 'INCREASE_ITEM_SHOPPING_BAG'
export const DECREASE_ITEM_SHOPPING_BAG = 'DECREASE_ITEM_SHOPPING_BAG'
export const SET_CARD_MESSAGE = 'SET_CARD_MESSAGE'
export const SET_ORDER_ID = 'SET_ORDER_ID'
export const SET_ORDER_ERRORS = 'SET_ORDER_ERRORS'
export const SET_CONFIRMED_ORDER_RECIPIENT = 'SET_CONFIRMED_ORDER_RECIPIENT'
export const CLEAR_ORDER = 'CLEAR_ORDER'
export const RESET_ORDER_STATE = 'RESET_ORDER_STATE'
export const DISABLE_PAY_BUTTON = 'DISABLE_PAY_BUTTON'
export const SET_SELECTED_TEMPLATE = 'SET_SELECTED_TEMPLATE'
export const SET_SALESFORCE_RESOURCE_TYPE = 'SET_SALESFORCE_RESOURCE_TYPE'
export const SET_SALESFORCE_RECORD_UID = 'SET_SALESFORCE_RECORD_UID'
export const IS_CREATING_ORDER = 'IS_CREATING_ORDER'
export const HANDLE_VARIANT_SELECTION = 'HANDLE_VARIANT_SELECTION'
export const SET_CHECK_INVENTORY_RESPONSE = 'SET_CHECK_INVENTORY_RESPONSE'

// recipients
export const LOAD_RECIPIENTS = 'LOAD_RECIPIENTS'
export const SET_RECIPIENTS = 'SET_RECIPIENTS'
export const CREATING_RECIPIENT = 'CREATING_RECIPIENT'
export const ADD_RECIPIENT = 'ADD_RECIPIENT'
export const SET_SELECTED_RECIPIENT = 'SET_SELECTED_RECIPIENT'
export const LOAD_RECIPIENT = 'LOAD_RECIPIENT'
export const SET_RECIPIENT = 'SET_RECIPIENT'
export const CLEAR_RECIPIENT_OBJECT = 'CLEAR_RECIPIENT_OBJECT'
export const RESET_RECIPIENT_STATE = 'RESET_RECIPIENT_STATE'
export const LOAD_RECIPIENT_LIST = 'LOAD_RECIPIENT_LIST'
export const SET_RECIPIENT_LIST = 'SET_RECIPIENT_LIST'
export const SET_RECIPIENT_LIST_ECOMMERCE_RECORDS =
  'SET_RECIPIENT_LIST_ECOMMERCE_RECORDS'
export const SET_RECIPIENT_ERRORS = 'SET_RECIPIENT_ERRORS'
export const SET_RECIPIENT_LIST_RECORDS = 'SET_RECIPIENT_LIST_RECORDS'
export const SET_RECIPIENT_LIST_DETAILS = 'SET_RECIPIENT_LIST_DETAILS'
export const SET_RECIPIENT_TYPE = 'SET_RECIPIENT_TYPE'
export const SET_SELECTED_RECIPIENT_LIST = 'SET_SELECTED_RECIPIENT_LIST'
export const SET_SELECTED_ECOMMERCE_RECIPIENT_LIST =
  'SET_SELECTED_ECOMMERCE_RECIPIENT_LIST'
export const DELETE_SELECTED_RECIPIENT_LIST = 'DELETE_SELECTED_RECIPIENT_LIST'

export const SET_ORDER_RECIPIENT_LIST = 'SET_ORDER_RECIPIENT_LIST'
// card templates
export const SET_CARDS = 'SET_CARDS'
export const LOAD_CARDS = 'LOAD_CARDS'
export const LOAD_CARD_TEMPLATES = 'LOAD_CARD_TEMPLATES'
export const SET_CARD_TEMPLATES = 'SET_CARD_TEMPLATES'
export const RESET_CARD_TEMPLATES_STATE = 'RESET_CARD_TEMPLATES_STATE'
export const ADD_NEW_CARD_TEMPLATE = 'ADD_NEW_CARD_TEMPLATE'
export const REMOVE_CARD_TEMPLATE = 'REMOVE_CARD_TEMPLATE'
export const UPDATE_CARD_TEMPLATE = 'UPDATE_CARD_TEMPLATE'
export const TEMPLATE_PAGINATION = 'TEMPLATE_PAGINATION'
export const TEMPLATE_SAVING = 'TEMPLATE_SAVING'

// team
export const LOAD_MEMBERS_LIST = 'LOAD_MEMBERS_LIST'
export const SET_MEMBERS = 'SET_MEMBERS'
export const UPDATE_MEMBER = 'UPDATE_MEMBER'
export const START_SEND_INVITATIONS = 'START_SEND_INVITATIONS'
export const END_SEND_INVITATIONS = 'END_SEND_INVITATIONS'
export const LOAD_INVITATIONS = 'LOAD_INVITATIONS'
export const SET_INVITATION_DETAILS = 'SET_INVITATION_DETAILS'
export const SET_INVITATIONS = 'SET_INVITATIONS'
export const ADD_INVITATION = 'ADD_INVITATION'
export const RESET_TEAM_STATE = 'RESET_TEAM_STATE'
export const ADD_USER_TO_REMOVE = 'ADD_USER_TO_REMOVE'
export const CLEAN_USER_TO_REMOVE = 'CLEAN_USER_TO_REMOVE'
export const SET_CURRENT_TEAM = 'SET_CURRENT_TEAM'
export const REMOVE_USER_FROM_TEAM = 'REMOVE_USER_FROM_TEAM'
export const REMOVE_INVITATION = 'REMOVE_INVITATION'
export const SET_NEW_SUBTEAM_FOR_MEMBER = 'SET_NEW_SUBTEAM_FOR_MEMBER'
export const SET_MEMBERS_PAGINATION_COUNT = 'SET_MEMBERS_PAGINATION_COUNT'
export const SET_INVITATION_PAGINATION_COUNT = 'SET_INVITATION_PAGINATION_COUNT'
export const SET_TEAM_AVAILABLE_ORDERS = 'SET_TEAM_AVAILABLE_ORDERS'
// billing
export const LOAD_PAYMENT_METHODS = 'LOAD_PAYMENT_METHODS'
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS'
export const SET_UPDATED_PAYMENT_METHOD = 'SET_UPDATED_PAYMENT_METHOD'
export const REMOVE_PAYMENT_METHOD = 'REMOVE_PAYMENT_METHOD'
export const ADDING_NEW_PAYMENT_METHOD = 'ADDING_NEW_PAYMENT_METHOD'
export const LOAD_INVOICES = 'LOAD_INVOICES'
export const SET_INVOICES = 'SET_INVOICES'
export const SET_PLANS = 'SET_PLANS'
export const LOAD_PLANS = 'LOAD_PLANS'
export const LOAD_SUBSCRIPTION_INFO = 'LOAD_SUBSCRIPTION_INFO'
export const SET_SUBSCRIPTION_INFO = 'SET_SUBSCRIPTION_INFO'
export const UPDATING_SUBSCRIPTION_INFO = 'UPDATING_SUBSCRIPTION_INFO'
export const SET_SELECTED_PLAN_IF_NO_PAYMENT_METHODS =
  'SET_SELECTED_PLAN_IF_NO_PAYMENT_METHODS'
export const LOAD_SUBSCRIPTION_ALERTS = 'LOAD_SUBSCRIPTIONS_ALERTS'
export const SET_SUBSCRIPTION_ALERTS = 'SET_SUBSCRIPTION_ALERTS'
export const RESET_BILLING_STATE = 'RESET_BILLING_STATE'

export const SET_DEPOSIT_ERROR = 'SET_DEPOSIT_ERROR'
export const REMOVE_DEPOSIT_ERROR = 'REMOVE_DEPOSIT_ERROR'
export const SET_DEPOSIT_HISTORY = 'SET_DEPOSIT_HISTORY'
export const START_LOAD_DEPOSIT_INFO = 'START_LOAD_DEPOSIT_INFO'
export const END_LOAD_DEPOSIT_INFO = 'END_LOAD_DEPOSIT_INFO'
export const SET_DEPOSIT_INFO = 'SET_DEPOSIT_INFO'
export const SET_PAYMENT_METHOD_COUNT = 'SET_PAYMENT_METHOD_COUNT'
export const INVOICE_PAGINATION_COUNT = 'INVOICE_PAGINATION_COUNT'

// calendar
export const CHANGE_ORDER_DATES = 'CHANGE_ORDER_DATES'
export const CHANGE_REPORT_DATES = 'CHANGE_REPORT_DATES'

// integrations
export const SET_INTEGRATIONS = 'SET_INTEGRATIONS'
export const START_LOAD_INTEGRATIONS = 'START_LOAD_INTEGRATIONS'
export const END_LOAD_INTEGRATIONS = 'END_LOAD_INTEGRATIONS'
export const SET_SALESFORCE_RECORS = 'SET_SALESFORCE_RECORS'
export const LOAD_SALESFORCE_BY_RESOURCE_TYPE =
  'LOAD_SALESFORCE_BY_RESOURCE_TYPE'
export const RESET_INTEGRATIONS_STATE = 'RESET_INTEGRATIONS_STATE'
export const REMOVE_SALESFORCE_INTEGRATION = 'REMOVE_SALESFORCE_INTEGRATION'

// reports
export const LOAD_BAR_CHART = 'LOAD_BAR_CHART'
export const SET_COUNT_GIFTS_SENT = 'SET_COUNT_GIFTS_SENT'
export const SET_HISTORICAL_ORDERS_SENT_OBJECT =
  'SET_HISTORICAL_ORDERS_SENT_OBJECT'
export const RESET_REPORT_STATE = 'RESET_REPORT_STATE'
export const SET_INVENTORY_CHART = 'SET_INVENTORY_CHART'

export const LOAD_TRENDING_GIFTS = 'LOAD_TRENDING_GIFTS'
export const SET_TRENDING_GIFTS = 'SET_TRENDING_GIFTS'
export const LOAD_SHIPMENTS_METRICS = 'LOAD_SHIPMENTS_METRICS'
export const SET_AVERAGE_SHIPMENTS = 'SET_AVERAGE_SHIPMENTS'
export const SET_REMAINING_SHIPMENTS = 'SET_REMAINING_SHIPMENTS'
export const SET_SHIPMENT_CHART_DATA = 'SET_SHIPMENT_CHART_DATA'
export const SET_AVERAGE_SHIPMENT = 'SET_AVERAGE_SHIPMENT'
// inventory
export const LOAD_PRODUCTS_INVENTORY = 'LOAD_PRODUCT_INVENTORY'
export const SET_PRODUCTS_INVENTORY_LIST = 'SET_PRODUCT_INVENTORY_LIST'
export const LOAD_STORE_INVENTORY = 'LOAD_STORE_INVENTORY'
export const SET_STORE_INVENTORY = 'SET_STORE_INVENTORY'
export const ADD_PRODUCT_TO_REPLENISH = 'ADD_PRODUCT_TO_REPLENISH'
export const RESET_PRODUCTS_TO_REPLENISH = 'RESET_PRODUCTS_TO_REPLENISH'
export const REPLENISH_PRODUCTS = 'REPLENISH_PRODUCTS'
export const TOGGLING_PRODUCT_VISIBILITY = 'TOGGLING_PRODUCT_VISIBILITY'
export const SET_UPDATED_PRODUCT_INVENTORY = 'SET_UPDATED_PRODUCT_INVENTORY'
export const RESET_INVENTORY_STATE = 'RESET_INVENTORY_STATE'
export const INVENTORY_PAGINATION_COUNT = 'INVENTORY_PAGINATION_COUNT'
export const STORE_INVENTORY_PAGINATION = 'STORE_INVENTORY_PAGINATION'
export const REQUEST_ESTIMATE_COUNTER = 'REQUEST_ESTIMATE_COUNTER'
export const UPDATING_PRODUCT = 'UPDATING_PRODUCT'
export const UPDATE_PRODUCT_REPLENISH_QUANTITY =
  'UPDATE_PRODUCT_REPLENISH_QUANTITY'
export const UPDATE_PRODUCT_REPLENISH_ERROR = 'UPDATE_PRODUCT_REPLENISH_ERROR'
export const SET_STOCK_THRESHOLD_VALUE = 'SET_STOCK_THRESHOLD_VALUE'

// group order admin
export const CREATING_GROUP_ORDER = 'CREATING_GROUP_ORDER'
export const CREATING_GROUP_ORDER_STEP = 'CREATING_GROUP_ORDER_STEP'
export const CURRENT_GROUP_ORDER_DETAILS = 'CURRENT_GROUP_ORDER_DETAILS'
export const LOAD_GROUP_ORDER_PRODUCTS = 'LOAD_GROUP_ORDER_PRODUCTS'
export const SET_GROUP_ORDER_PRODUCTS = 'SET_GROUP_ORDER_PRODUCTS'
export const LOAD_GROUP_ORDER = 'LOAD_GROUP_ORDER'
export const SET_GROUP_ORDER_DETAILS = 'SET_GROUP_ORDER_DETAILS'
export const SET_GROUP_ORDER_TIERS = 'SET_GROUP_ORDER_TIERS'
export const ADD_NEW_TIER_TO_GROUP_ORDER = 'ADD_NEW_TIER_TO_GROUP_ORDER'
export const SAVE_TEMP_GROUP_ORDER_TIER = 'SAVE_TEMP_GROUP_ORDER_TIER'
export const UPDATE_GROUP_ORDER_TIER = 'UPDATE_GROUP_ORDER_TIER'
export const RESTORE_TEMP_GROUP_ORDER_TIER = 'RESTORE_TEMP_GROUP_ORDER_TIER'
export const REMOVE_GROUP_ORDER_TIER = 'REMOVE_GROUP_ORDER_TIER'
export const MARK_TEMPORALY_TIER_ITEM = 'MARK_TEMPORALY_TIER_ITEM'
export const UNMARK_TEMPORALY_TIER_ITEM = 'UNMARK_TEMPORALY_TIER_ITEM'
export const SET_UPDATING_TIER_ITEMS = 'SET_UPDATING_TIER_ITEMS'
export const SAVE_TIER_ITEMS_TO_REMOVE = 'SAVE_TIER_ITEMS_TO_REMOVE'
export const SET_REMOVE_MULTIPLE_TIER_ITEMS_STATUS =
  'SET_REMOVE_MULTIPLE_TIER_ITEMS_STATUS'
export const UNSAVE_TIER_ITEMS_TO_REMOVE = 'UNSAVE_TIER_ITEMS_TO_REMOVE'
export const RESET_TIER_ITEMS_TO_REMOVE = 'RESET_TIER_ITEMS_TO_REMOVE'
export const CLEAR_TEMPORALY_TIER_ITEMS = 'CLEAR_TEMPORALY_TIER_ITEMS'
export const ADD_NEW_ITEM_TO_TIER = 'ADD_NEW_ITEM_TO_TIER'
export const SAVE_TEMP_ITEM_TO_REMOVE = 'SAVE_TEMP_ITEM_TO_REMOVE'
export const RESTORE_TEMP_ITEM_TO_REMOVE = 'RESTORE_TEMP_ITEM_TO_REMOVE'
export const CLEAR_TEMP_ITEM_TO_REMOVE = 'CLEAR_TEMP_ITEM_TO_REMOVE'
export const REMOVE_ITEM_FROM_TIER = 'REMOVE_ITEM_FROM_TIER'
export const UPDATING_GROUP_ORDER_PASSWORD = 'UPDATING_GROUP_ORDER_PASSWORD'
export const LOAD_GROUP_ORDERS_LIST = 'LOAD_GROUP_ORDERS_LIST'
export const SET_GROUP_ORDERS_LIST = 'SET_GROUP_ORDERS_LIST'
export const LOAD_GROUP_ORDER_ITEMS_ORDERED = 'LOAD_GROUP_ORDER_ITEMS_ORDERED'
export const SET_GROUP_ORDER_ITEMS_ORDERED = 'SET_GROUP_ORDER_ITEMS_ORDERED'
export const LOAD_GROUP_ORDER_RECIPIENTS_LIST =
  'LOAD_GROUP_ORDER_RECIPIENTS_LIST'
export const SET_GROUP_ORDER_RECIPIENT_LIST = 'SET_GROUP_ORDER_RECIPIENT_LIST'
export const SET_GROUP_ORDER_RECIPIENTS_EXPORT_LIST =
  'SET_GROUP_ORDER_RECIPIENTS_EXPORT_LIST'
export const LOAD_RECIPIENTS_GROUP_ORDER_SELECTED_ITEMS =
  'LOAD_RECIPIENT_GROUP_ORDER_SELECTED_ITEMS'
export const SET_RECIPIENTS_SELECTED_ITEMS = 'SET_RECIPIENTS_SELECTED_ITEMS'
export const IS_FINALIZING_GROUP_ORDER = 'IS_FINALIZING_GROUP_ORDER'
export const ADD_RECIPIENT_TO_BE_SKIPPED_O_REMOVED_FROM_GO =
  'ADD_RECIPIENT_TO_BE_SKIPPED_O_REMOVED_FROM_GO'
export const REMOVE_RECIPIENT_FROM_GROUP_ORDER =
  'REMOVE_RECIPIENT_FROM_GROUP_ORDER'
export const CLEAN_RECIPIENTS_LIST_TO_REMOVE = 'CLEAN_RECIPIENTS_LIST_TO_REMOVE'
export const LOAD_ALLOW_LIST = 'LOAD_ALLOW_LIST'
export const LOAD_ALLOW_LIST_ECOMMERCE = 'LOAD_ALLOW_LIST_ECOMMERCE'
export const SET_ALLOW_LIST = 'SET_ALLOW_LIST'
export const SET_ALLOW_LIST_ECOMMERCE = 'SET_ALLOW_LIST_ECOMMERCE'
export const REMOVED_ALL_USERS_FROM_ALLOW_LIST =
  'REMOVED_ALL_USERS_FROM_ALLOW_LIST'
export const ALLOW_LIST_UPLOADED = 'ALLOW_LIST_UPLOADED'
export const REDEMPTION_UUID = 'REDEMPTION_UUID'

// group order recipients
export const LOAD_GROUP_ORDER_INFO = 'LOAD_GROUP_ORDER_INFO'
export const VALIDATING_GROUP_ORDER_RECIPIENT =
  'VALIDATING_GROUP_ORDER_RECIPIENT'
export const SET_GROUP_ORDER_RECIPIENT = 'SET_GROUP_ORDER_RECIPIENT'
export const LOAD_GROUP_ORDER_TIERS_FOR_RECIPIENT =
  'LOAD_GROUP_ORDER_TIERS_FOR_RECIPIENT'
export const SET_SELECTABLE_GROUP_ORDER_TIERS =
  'SET_SELECTABLE_GROUP_ORDER_TIERS'
export const SET_CURRENT_ITEMS_SELECTED = 'SET_CURRENT_ITEMS_SELECTED'
export const ACTIVATE_ITEM = 'ACTIVATE_ITEM'
export const DEACTIVATE_ITEM = 'DEACTIVATE_ITEM'
export const ADD_NEW_ITEM_TO_RECIPIENT_SELECTION =
  'ADD_NEW_ITEM_TO_RECIPIENT_SELECTION'
export const SET_REALID_TO_ITEM_RECIPIENT_SELECTION =
  'SET_REALID_TO_ITEM_RECIPIENT_SELECTION'
export const REMOVE_TEMP_ITEM_RECIPIENT_SELECTION =
  'REMOVE_TEMP_ITEM_RECIPIENT_SELECTION'

export const REMOVE_ITEM_FROM_RECIPIENT_SELECTION =
  'REMOVE_ITEM_FROM_RECIPIENT_SELECTION'
export const SAVE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION =
  'SAVE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION'
export const CLEAR_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION =
  'CLEAR_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION'
export const RESTORE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION =
  'RESTORE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION'

export const REMOVE_BUNDLE_ITEMS_RECIPIENT_SELECTION =
  'REMOVE_BUNDLE_ITEMS_RECIPIENT_SELECTION'
export const SAVE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION =
  'SAVE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION'
export const CLEAR_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION =
  'CLEAR_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION'
export const RESTORE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION =
  'RESTORE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION'

export const UPDATING_GROUP_ORDER_RECIPIENT = 'UPDATING_GROUP_ORDER_RECIPIENT'
export const CONFIRM_RECIPIENT_GROUP_ORDER = 'CONFIRM_RECIPIENT_GROUP_ORDER'
export const IS_CONFIRMING_GROUP_ORDER = 'IS_CONFIRMING_GROUP_ORDER'
export const RESET_GROUP_ORDER_STATE = 'RESET_GROUP_ORDER_STATE'
export const SET_ORDERSTORE_PAGINATION_TOTAL_COUNT =
  'SET_ORDERSTORE_PAGINATION_TOTAL_COUNT'
export const SET_RECIPIENT_PAGINATION = 'SET_RECIPIENT_PAGINATION'
export const SET_GROUP_ORDER_STATE = 'SET_GROUP_ORDER_STATE'
export const GETTING_SHIPPING_DETAILS = 'GETTING_SHIPPING_DETAILS'
export const SET_RECIPIENTLIST_TOTAL_COUNT = 'SET_RECIPIENTLIST_TOTAL_COUNT'
export const VERIFICATION_EMAIL_STATUS = 'VERIFICATION_EMAIL_STATUS'

// sub teams
export const LOAD_SUBTEAMS_LIST = 'LOAD_SUBTEAMS_LIST'
export const SET_SUBTEAMS_LIST = 'SET_SUBTEAMS_LIST'
export const ADDING_NEW_SUBTEAM = 'ADDING_NEW_SUBTEAM'
export const SET_NEW_SUBTEAM = 'SET_NEW_SUBTEAM'
export const UPDATE_SUBTEAM = 'UPDATE_SUBTEAM'
export const REMOVING_SUBTEAM = 'REMOVING_TEAM'
export const REMOVE_SUBTEAM_FROM_LIST = 'REMOVE_SUBTEAM_FROM_LIST'
export const REMOVE_USER_FROM_SUBTEAM = 'REMOVE_USER_FROM_SUBTEAM'

// projects
export const LOAD_PROJECTS_LIST = 'LOAD_PROJECTS_LIST'
export const SET_PROJECTS_LIST = 'SET_PROJECTS_LIST'
export const LOAD_PROJECT_DETAILS = 'LOAD_PROJECT_DETAILS'
export const SET_PROJECT_DETAILS = 'SET_PROJECT_DETAILS'
export const LOAD_PROJECT_LINK_INFO = 'LOAD_PROJECT_LINK_INFO'
export const SET_PROJECT_INFO = 'SET_PROJECT_INFO'
export const SET_RECIPIENT_CUSTOM_SIZES = 'SET_RECIPIENT_CUSTOM_SIZES'
export const SETTING_PROJECT_RECIPIENT_INFO = 'SETTING_PROJECT_RECIPIENT_INFO'
export const PROJECT_EMAIL_ALREADY_IN_USE = 'PROJECT_EMAIL_ALREADY_IN_USE'
export const UPDATING_ALLOWED_DOMAIN = 'UPDATING_ALLOWED_DOMAIN'
export const UPDATING_RECIPIENT = 'UPDATING_RECIPIENT'
export const ENABLE_ADDRESS_COLLECTION = 'ENABLE_ADDRESS_COLLECTION'
export const DISABLE_ADDRESS_COLLECTION = 'DISABLE_ADDRESS_COLLECTION'
export const SET_COLLECTION_LINK_STATE = 'SET_COLLECTION_LINK_STATE'

export const DELETING_RECIPIENT = 'DELETING_RECIPIENT'
export const FINALIZING_ORDER = 'FINALIZING_ORDER'
export const SEARCHING_RECIPIENT = 'SEARCHING_RECIPIENT'
export const SET_RECIPIENT_INFO = 'SET_RECIPIENT_INFO'
export const UPDATE_RECIPIENT_INFO = 'UPDATE_RECIPIENT_INFO'
export const SET_RECIPIENT_VERIFICATION_STATUS =
  'SET_RECIPIENT_VERIFICATION_STATUS'

// public projects
export const SET_PUBLIC_PROJECT_DETAILS = 'SET_PUBLIC_PROJECT_DETAILS'
export const SET_PUBLIC_RECIPIENTS_PAGINATION_COUNT =
  'SET_PUBLIC_RECIPIENTS_PAGINATION_COUNT'
export const SET_PUBLIC_PROJECT_RECIPIENTS = 'SET_PUBLIC_PROJECT_RECIPIENTS'
export const UPDATING_PUBLIC_RECIPIENT = 'UPDATING_PUBLIC_RECIPIENT'
export const LOAD_PUBLIC_PROJECT_DETAILS = 'LOAD_PUBLIC_PROJECT_DETAILS'
export const LOAD_PUBLIC_PROJECT_RECIPIENTS = 'LOAD_PUBLIC_PROJECT_RECIPIENTS'
export const FINALIZING_PUBLIC_ORDER = 'FINALIZING_PUBLIC_ORDER'

// e-commerce
export const CREATING_STORE = 'CREATING_STORE'
export const DISPLAY_SHOP_SIDEBAR = 'DISPLAY_SHOP_SIDEBAR'
export const LOAD_SHOP_DETAILS = 'LOAD_SHOP_DETAILS'
export const SET_SHOP_DETAILS = 'SET_SHOP_DETAILS'
export const UPDATING_SHOP = 'UPDATING_SHOP'
export const ENABLE_DISABLE_SHOP = 'ENABLE_DISABLE_SHOP'
export const CONNECTING_STRIPE = 'CONNECTING_STRIPE'
export const SET_STRIPE_BLOB = 'SET_STRIPE_BLOB'
export const SET_SHOP_STATS = 'SET_SHOP_STATS'
export const SET_LOADING_SHOP_STAT = 'SET_LOADING_SHOP_STAT'
export const SET_LOADING_SHOP_ORDERS = 'SET_LOADING_SHOP_ORDERS'
export const SET_SHOP_ORDERS = 'SET_SHOP_ORDERS'
export const SET_LOADING_PAYOUTS = 'SET_LOADING_PAYOUTS'
export const SET_SHOP_PAYOUTS = 'SET_SHOP_PAYOUTS'
export const SET_LOADING_ORDER = 'SET_LOADING_ORDER'
export const SET_LOADING_PRODUCT_IMAGES = 'SET_LOADING_PRODUCT_IMAGES'
export const SET_CREATING_PRODUCT_IMAGES = 'SET_CREATING_PRODUCT_IMAGES'
export const SET_PRODUCT_ATTRIBUTES = 'SET_PRODUCT_ATTRIBUTES'
export const SET_SELECTED_IMAGE_ID = 'SET_SELECTED_IMAGE_ID'
export const SET_PRODUCT_DEFAULT_IMAGE = 'SET_PRODUCT_DEFAULT_IMAGE'
export const RESET_PRODUCT_ATTRIBUTES = 'RESET_PRODUCT_ATTRIBUTES'
export const SET_SELECTED_PRODUCT_VARIANTS = 'SET_SELECTED_PRODUCT_VARIANTS'
export const SET_UPDATING_PRODUCT_VARIANTS = 'SET_UPDATING_PRODUCT_VARIANTS'
export const SET_ECOM_PRODUCT_VARIANTS = 'SET_ECOM_PRODUCT_VARIANTS'
export const SET_ORDER = 'SET_ORDER'
export const SET_EXPORTING_PAYOUT = 'SET_EXPORTING_PAYOUT'
export const SET_EXPORTING_ORDER = 'SET_EXPORTING_ORDER'
export const SET_LOADING_PRODUCTS = 'SET_LOADING_PRODUCTS'
export const SET_STORE_PRODUCTS = 'SET_STORE_PRODUCTS'
export const SET_LOADING_CHECK_DNS = 'SET_LOADING_CHECK_DNS'
export const SET_DNS_STATUS = 'SET_DNS_STATUS'

// e-commerce gift cards
export const FETCHING_GIFT_CARDS = 'FETCHING_GIFT_CARDS'
export const CREATING_GIFT_CARD = 'CREATING_GIFT_CARD'
export const DELETING_GIFT_CARD = 'DELETING_GIFT_CARD'
export const SET_GIFT_CARDS = 'SET_GIFT_CARDS'
export const SET_GIFT_CARDS_TOTAL_COUNT = 'SET_GIFT_CARDS_TOTAL_COUNT'
export const SELECT_ALL_GIFT_CARDS = 'SELECT_ALL_GIFT_CARDS'
export const RESET_SELECTED_GIFT_CARDS = 'RESET_SELECTED_GIFT_CARDS'
export const SET_SELECTED_GIFT_CARDS = 'SET_SELECTED_GIFT_CARDS'

// e-commerce public
export const LOAD_PUBLIC_STORE = 'LOAD_PUBLIC_STORE'
export const SET_PUBLIC_STORE = 'SET_PUBLIC_STORE'
export const SET_PUBLIC_STORE_PRODUCTS = 'SET_PUBLIC_STORE_PRODUCTS'
export const LOAD_STORE_PRODUCT_DETAILS =
  'LOAD_STORE_PRODUCT_DETAILSLOAD_STORE_PRODUCT_DETAILS'
export const SET_STORE_PRODUCT = 'SET_STORE_PRODUCT'
export const SET_STORE_PRODUCT_VARIANTS = 'SET_STORE_PRODUCT_VARIANTS'
export const SET_STORE_VARIANT_DICTIONARY = 'SET_STORE_VARIANT_DICTIONARY'
export const SET_STORE_VARIANTS_IMAGES = 'SET_STORE_VARIANTS_IMAGES'
export const SET_STORE_VARIANT_TYPES = 'SET_STORE_VARIANT_TYPES'
export const SET_STORE_VARIANT_COLORS = 'SET_STORE_VARIANT_COLORS'
export const SET_STORE_VARIANT_SIZES = 'SET_STORE_VARIANT_SIZES'
export const PRODUCT_STORE_NOT_FOUND = 'PRODUCT_STORE_NOT_FOUND'
export const UPDATE_STORE_VARIANT_SIZES = 'UPDATE_STORE_VARIANT_SIZES'
export const UPDATE_STORE_VARIANT_COLORS = 'UPDATE_STORE_VARIANT_COLORS'
export const LOAD_SUGGESTED_STORE_PRODUCTS = 'LOAD_SUGGESTED_STORE_PRODUCTS'
export const SET_SUGGESTED_STORE_PRODUCTS = 'SET_SUGGESTED_STORE_PRODUCTS'

export const LOAD_STORE_CART = 'LOAD_STORE_CART'
export const SET_STORE_CART = 'SET_STORE_CART'
export const IS_ADDING_ITEM_TO_CART = 'IS_ADDING_ITEM_TO_CART'
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART'
export const IS_REMOVING_CART_ITEM = 'IS_REMOVING_CART_ITEM'
export const IS_UPDATING_CART_ITEM = 'IS_UPDATING_CART_ITEM'
export const IS_SETTING_SHIPPING_ADDRESS = 'IS_SETTING_SHIPPING_ADDRESS'
export const ROLL_UP_SHIPPING_ADDRESS = 'ROLL_UP_SHIPPING_ADDRESS'
export const ROLL_DOWN_FORM_BILLING_ADDRESS = 'ROLL_DOWN_FORM_BILLING_ADDRESS'
export const SET_PAYMENT_DETAILS = 'SET_PAYMENT_DETAILS'
export const CREATING_PAYMENT_INTENT = 'CREATING_PAYMENT_INTENT'
export const SET_PAYMENT_CLIENT_SECRET = 'SET_PAYMENT_CLIENT_SECRET'

export const SHOW_ADD_TO_CART_NOTIFICATION = 'SHOW_ADD_TO_CART_NOTIFICATION'
export const HIDE_ADD_TO_CART_NOTIFICATION = 'HIDE_ADD_TO_CART_NOTIFICATION'
export const UPDATING_AUTO_FINALIZING = 'UPDATING_AUTO_FINALIZING'
